import { render, staticRenderFns } from "./h5Prorram.vue?vue&type=template&id=1783176e"
import script from "./h5Prorram.vue?vue&type=script&lang=js"
export * from "./h5Prorram.vue?vue&type=script&lang=js"
import style0 from "./h5Prorram.vue?vue&type=style&index=0&id=1783176e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports